import { computed, readonly, ref } from 'vue'
import { getStdProjectInfo, updateStdProject } from '@/api/convert.model.js'
import { getAccountById } from '@/api/ptom.data.model.js'
import {
  buildStdProjectUpdateRequest,
  getOriginalMaterialTotal,
  rebuildStdProjectForm,
  validateStdProjectBeforeSubmit
} from '../model/standardProjectAdapter.js'

export function useStdProjectEdit({ accountId, projectId }) {
  const form = ref(null)
  const rawDetail = ref(null)
  const loading = ref(false)
  const submitLoading = ref(false)
  const loadError = ref('')
  const lastSubmitResult = ref(null)

  const loaded = computed(() => Boolean(form.value && rawDetail.value))
  const submitDisabled = computed(() => loading.value || submitLoading.value || !loaded.value)

  async function load() {
    loading.value = true
    loadError.value = ''
    try {
      const [detail, account] = await Promise.all([
        getStdProjectInfo({ accountId, projectId }),
        getAccountById({ ad_account_id: accountId })
      ])
      if (!detail) throw new Error('获取智擎标准项目信息失败')

      rawDetail.value = detail
      form.value = await rebuildStdProjectForm(detail, { account, accountId })
      return form.value
    } catch (e) {
      loadError.value = e.message || '获取智擎标准项目信息失败'
      throw e
    } finally {
      loading.value = false
    }
  }

  async function submit() {
    validateStdProjectBeforeSubmit(form.value, { originalMaterialTotal: getOriginalMaterialTotal(rawDetail.value) })

    submitLoading.value = true
    try {
      const request = buildStdProjectUpdateRequest({
        accountId,
        projectId,
        form: form.value,
        rawDetail: rawDetail.value
      })
      const result = await updateStdProject(request)
      if (!result) throw new Error('修改智擎标准项目失败')
      lastSubmitResult.value = result
      return result
    } finally {
      submitLoading.value = false
    }
  }

  return {
    form,
    rawDetail: readonly(rawDetail),
    loading: readonly(loading),
    submitLoading: readonly(submitLoading),
    loadError: readonly(loadError),
    lastSubmitResult: readonly(lastSubmitResult),
    loaded,
    submitDisabled,
    load,
    submit
  }
}
